const blockStats = document.querySelector(".block-with-stats");
const blockStatsNumbers = Array.from(document.querySelectorAll(".block-with-stats p"));

/**
 * @description - Function checks if element is in the viewport and adds appropriate class to it.
 */
const showBlockStatsWhenInViewport = debounce(() => {
  if (blockStats && isInViewport(blockStats)) {
    if (!blockStats.classList.contains("in-viewport")) {
      setTimeout(function() {
        blockStatsNumbers.forEach(item => {
          if (!blockStats.classList.contains("in-viewport")) {
            $(item).animateNumber({ number: $(item).text() }, 2500);
          }
        });
        blockStats.classList.add("in-viewport");
      }, 1000);
    }
  }
}, 30);

/**
 * Initialize functions on start and on scroll
 */
showBlockStatsWhenInViewport();

$(window).on("scroll touchmove", showBlockStatsWhenInViewport);
